import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { AuthContext } from '../../contexts/AuthContext';
import { useSettings } from '../../contexts/SettingsContext';
import { complaintAPI, noticeAPI } from '../../services/api';
import PageTitle from '../shared/PageTitle';

// Generate dynamic styles based on theme settings
const generateMaintenanceStyles = (settings) => `
  .maintenance-dashboard .stat-card {
    border: none !important;
    border-radius: 16px !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.3s ease !important;
    position: relative !important;
    overflow: hidden !important;
    margin-bottom: 1.5rem !important;
    height: 100%;
  }
  
  .maintenance-dashboard .stat-card:hover {
    transform: translateY(-5px) !important;
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15) !important;
  }
  
  .maintenance-dashboard .stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    z-index: 1;
  }
  
  .maintenance-dashboard .stat-card-danger {
    background: linear-gradient(135deg, 
      ${settings.btn_danger_bg || '#dc3545'}20 0%, 
      ${settings.btn_danger_bg || '#dc3545'}10 40%,
      ${settings.card_bg_color || '#ffffff'} 50%,
      ${settings.card_bg_color || '#ffffff'} 100%) !important;
  }
  
  .maintenance-dashboard .stat-card-danger::before {
    background: linear-gradient(90deg, ${settings.btn_danger_bg || '#dc3545'}, #ff6b7a) !important;
  }
  
  .maintenance-dashboard .stat-card-warning {
    background: linear-gradient(135deg, 
      ${settings.btn_warning_bg || '#ffc107'}20 0%, 
      ${settings.btn_warning_bg || '#ffc107'}10 40%,
      ${settings.card_bg_color || '#ffffff'} 50%,
      ${settings.card_bg_color || '#ffffff'} 100%) !important;
  }
  
  .maintenance-dashboard .stat-card-warning::before {
    background: linear-gradient(90deg, ${settings.btn_warning_bg || '#ffc107'}, #ffd54f) !important;
  }
  
  .maintenance-dashboard .stat-card-success {
    background: linear-gradient(135deg, 
      ${settings.btn_success_bg || '#198754'}20 0%, 
      ${settings.btn_success_bg || '#198754'}10 40%,
      ${settings.card_bg_color || '#ffffff'} 50%,
      ${settings.card_bg_color || '#ffffff'} 100%) !important;
  }
  
  .maintenance-dashboard .stat-card-success::before {
    background: linear-gradient(90deg, ${settings.btn_success_bg || '#198754'}, #66bb6a) !important;
  }
  
  .maintenance-dashboard .stat-card-primary {
    background: linear-gradient(135deg, 
      ${settings.theme_primary_color || settings.btn_primary_bg || '#0d6efd'}20 0%, 
      ${settings.theme_primary_color || settings.btn_primary_bg || '#0d6efd'}10 40%,
      ${settings.card_bg_color || '#ffffff'} 50%,
      ${settings.card_bg_color || '#ffffff'} 100%) !important;
  }
  
  .maintenance-dashboard .stat-card-primary::before {
    background: linear-gradient(90deg, ${settings.theme_primary_color || settings.btn_primary_bg || '#0d6efd'}, #42a5f5) !important;
  }
  
  .maintenance-dashboard .stat-icon-wrapper {
    width: 80px !important;
    height: 80px !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 auto 1rem auto !important;
    position: relative !important;
    z-index: 2 !important;
  }
  
  .maintenance-dashboard .stat-card-danger .stat-icon-wrapper {
    background: ${settings.btn_danger_bg || '#dc3545'} !important;
    color: ${settings.btn_danger_text || '#ffffff'} !important;
    box-shadow: 0 8px 20px ${settings.btn_danger_bg || '#dc3545'}40 !important;
  }
  
  .maintenance-dashboard .stat-card-warning .stat-icon-wrapper {
    background: ${settings.btn_warning_bg || '#ffc107'} !important;
    color: ${settings.btn_warning_text || '#000000'} !important;
    box-shadow: 0 8px 20px ${settings.btn_warning_bg || '#ffc107'}40 !important;
  }
  
  .maintenance-dashboard .stat-card-success .stat-icon-wrapper {
    background: ${settings.btn_success_bg || '#198754'} !important;
    color: ${settings.btn_success_text || '#ffffff'} !important;
    box-shadow: 0 8px 20px ${settings.btn_success_bg || '#198754'}40 !important;
  }
  
  .maintenance-dashboard .stat-card-primary .stat-icon-wrapper {
    background: ${settings.theme_primary_color || settings.btn_primary_bg || '#0d6efd'} !important;
    color: ${settings.btn_primary_text || '#ffffff'} !important;
    box-shadow: 0 8px 20px ${settings.theme_primary_color || settings.btn_primary_bg || '#0d6efd'}40 !important;
  }
  
  .maintenance-dashboard .stat-icon {
    font-size: 2rem !important;
    font-weight: 600 !important;
  }
  
  .maintenance-dashboard .stat-title {
    font-size: 1rem !important;
    font-weight: 700 !important;
    color: #2c3e50 !important;
    margin-bottom: 0.75rem !important;
    text-transform: uppercase !important;
    letter-spacing: 0.8px !important;
    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8) !important;
  }
  
  .maintenance-dashboard .stat-number {
    font-size: 3.5rem !important;
    font-weight: 800 !important;
    color: #1a252f !important;
    margin-bottom: 0.5rem !important;
    line-height: 1 !important;
    text-shadow: 0 2px 4px rgba(255, 255, 255, 0.9) !important;
  }
  
  .maintenance-dashboard .stat-subtitle {
    font-size: 0.75rem !important;
    color: #34495e !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8) !important;
    opacity: 0.9 !important;
  }
  
  .maintenance-dashboard .card-body {
    padding: 2rem 1.5rem 0 !important;
    background-color: transparent !important;
    position: relative !important;
    z-index: 2 !important;
  }

  @media (max-width: 767px) {
    .maintenance-dashboard .card-body {
      padding: 2rem 1.5rem 2rem !important;
    }
  }
  
  .maintenance-dashboard .card-header {
    background-color: ${settings.block_title_bg_color || '#f8f9fa'} !important;
    color: ${settings.block_title_color || '#212529'} !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
  
  .maintenance-dashboard .card-header h5 {
    color: ${settings.block_title_color || '#212529'} !important;
    margin: 0 !important;
  }
  
  .maintenance-dashboard .btn-primary {
    background-color: ${settings.btn_primary_bg || settings.theme_primary_color || '#0d6efd'} !important;
    border-color: ${settings.btn_primary_bg || settings.theme_primary_color || '#0d6efd'} !important;
    color: ${settings.btn_primary_text || '#ffffff'} !important;
  }
  
  .maintenance-dashboard .badge.bg-danger {
    background-color: ${settings.btn_danger_bg || '#dc3545'} !important;
    color: ${settings.btn_danger_text || '#ffffff'} !important;
  }
  
  .maintenance-dashboard .badge.bg-warning {
    background-color: ${settings.btn_warning_bg || '#ffc107'} !important;
    color: ${settings.btn_warning_text || '#000000'} !important;
  }
  
  .maintenance-dashboard .badge.bg-success {
    background-color: ${settings.btn_success_bg || '#198754'} !important;
    color: ${settings.btn_success_text || '#ffffff'} !important;
  }
  
  .maintenance-dashboard .table th {
    color: ${settings.block_title_color || '#212529'} !important;
    font-weight: 600 !important;
  }
  
  @media (max-width: 768px) {
    .maintenance-dashboard .stat-card {
      margin-bottom: 1rem !important;
    }
    
    .maintenance-dashboard .stat-number {
      font-size: 2.5rem !important;
    }
    
    .maintenance-dashboard .stat-icon-wrapper {
      width: 60px !important;
      height: 60px !important;
    }
    
    .maintenance-dashboard .stat-icon {
      font-size: 1.5rem !important;
    }
  }
`;

const Dashboard = () => {
  // const { currentUser } = useContext(AuthContext);
  const { settings } = useSettings();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    openComplaints: 0,
    inProgressComplaints: 0,
    resolvedComplaints: 0,
    totalComplaints: 0
  });
  const [recentComplaints, setRecentComplaints] = useState([]);
  const [rules, setRules] = useState([]);
  const [announcements, setAnnouncements] = useState([]);

  // Inject custom styles for maintenance dashboard
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.id = 'maintenance-dashboard-styles';
    styleElement.innerHTML = generateMaintenanceStyles(settings);
    document.head.appendChild(styleElement);

    return () => {
      // Cleanup styles when component unmounts
      const existingStyle = document.getElementById('maintenance-dashboard-styles');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, [settings]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Fetch complaints
        const response = await complaintAPI.getAllComplaints();

        if (response.data && Array.isArray(response.data)) {
          // Count stats
          const open = response.data.filter(c => c.status === 'open').length;
          const inProgress = response.data.filter(c => c.status === 'in_progress').length;
          const resolved = response.data.filter(c => c.status === 'resolved').length;

          setStats({
            openComplaints: open,
            inProgressComplaints: inProgress,
            resolvedComplaints: resolved,
            totalComplaints: response.data.length
          });

          // Get recent complaints
          const recent = [...response.data]
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .slice(0, 5);

          setRecentComplaints(recent);
        }
        setError(null);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to load complaint data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    // Execute fetchData and catch any unexpected errors to prevent uncaught rejections
    fetchData().catch(error => {
      console.error('Unexpected error fetching maintenance dashboard data:', error);
      setError('Failed to load complaint data. Please try again later.');
      setLoading(false);
    });
  }, []);

  // Fetch notices (rules and announcements) periodically
  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const [rulesRes, annRes] = await Promise.all([
          noticeAPI.getRules(),
          noticeAPI.getAnnouncements()
        ]);
        setRules(rulesRes.data);
        setAnnouncements(annRes.data);
      } catch (err) {
        console.error('Error fetching notices:', err);
      }
    };
    fetchNotices();
    const interval = setInterval(fetchNotices, 30000);
    return () => clearInterval(interval);
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'open':
        return <span className="badge bg-danger">Open</span>;
      case 'in_progress':
        return <span className="badge bg-warning">In Progress</span>;
      case 'resolved':
        return <span className="badge bg-success">Resolved</span>;
      default:
        return <span className="badge bg-secondary">Unknown</span>;
    }
  };

  if (loading) {
    return (
      <div className="maintenance-dashboard d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="maintenance-dashboard container-fluid p-4">
        <PageTitle icon="fa-tools" title="Maintenance Dashboard" />
        <div className="alert alert-danger">
          <i className="fas fa-exclamation-circle me-2"></i>
          {error}
        </div>
        <div className="card">
          <div className="card-body">
            <p>You can still access all complaints through the complaints menu:</p>
            <Link to="/maintenance/complaints" className="btn btn-primary">
              <i className="fas fa-tools me-2"></i>View Complaints / Suggestions
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="maintenance-dashboard container-fluid p-4">
      <PageTitle icon="fa-tools" title="Maintenance Dashboard" />

      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card stat-card stat-card-danger">
            <div className="card-body text-center">
              <div className="stat-icon-wrapper">
                <i className="fas fa-exclamation-triangle stat-icon"></i>
              </div>
              <h5 className="stat-title">Open Complaints / Suggestions</h5>
              <p className="stat-number">{stats.openComplaints}</p>
              <small className="stat-subtitle">Requires Attention</small>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card stat-card stat-card-warning">
            <div className="card-body text-center">
              <div className="stat-icon-wrapper">
                <i className="fas fa-clock stat-icon"></i>
              </div>
              <h5 className="stat-title">In Progress</h5>
              <p className="stat-number">{stats.inProgressComplaints}</p>
              <small className="stat-subtitle">Being Resolved</small>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card stat-card stat-card-success">
            <div className="card-body text-center">
              <div className="stat-icon-wrapper">
                <i className="fas fa-check-circle stat-icon"></i>
              </div>
              <h5 className="stat-title">Resolved</h5>
              <p className="stat-number">{stats.resolvedComplaints}</p>
              <small className="stat-subtitle">Completed</small>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card stat-card stat-card-primary">
            <div className="card-body text-center">
              <div className="stat-icon-wrapper">
                <i className="fas fa-chart-bar stat-icon"></i>
              </div>
              <h5 className="stat-title">Total</h5>
              <p className="stat-number">{stats.totalComplaints}</p>
              <small className="stat-subtitle">All Complaints / Suggestions</small>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Recent Complaints / Suggestions</h5>
              <Link to="/maintenance/complaints" className="btn btn-sm btn-primary">
                View All
              </Link>
            </div>
            <div className="card-body">
              {recentComplaints.length === 0 ? (
                <div className="alert alert-info">No complaints / suggestions found.</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Unit</th>
                        <th>Status</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentComplaints.map(complaint => (
                        <tr key={complaint.id}>
                          <td>#{complaint.id}</td>
                          <td>{complaint.title || complaint.subject}</td>
                          <td>{complaint.villa_number}</td>
                          <td>{getStatusBadge(complaint.status)}</td>
                          <td>{formatDate(complaint.created_at)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Notices Section */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0"><strong>Notices</strong></h5>
            </div>
            <div className="card-body">
              <h6 className="mt-2"><strong>Rules</strong></h6>
              {rules.length === 0 ? (
                <p>No rules available.</p>
              ) : (
                <ul className="list-group mb-3">
                  {rules.map(rule => (
                    <li key={rule.id} className="list-group-item">
                      <strong>{rule.title}</strong>
                      <p className="mb-0">{rule.description}</p>
                    </li>
                  ))}
                </ul>
              )}
              <h6 className="mt-2"><strong>Announcements</strong></h6>
              {announcements.length === 0 ? (
                <p>No announcements available.</p>
              ) : (
                <ul className="list-group">
                  {announcements.map(ann => (
                    <li key={ann.id} className="list-group-item">
                      <strong>{ann.title}</strong>
                      <small className="text-muted ms-2">
                        {new Date(ann.start_date).toLocaleDateString()}
                        {ann.expiry_date ? ` - ${new Date(ann.expiry_date).toLocaleDateString()}` : ''}
                      </small>
                      <p className="mb-0">{ann.description}</p>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Dashboard; 